import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { SpecificUserDiet, UserDiet } from "./UserDiet";
import { Aliment } from "../aliments/Aliment";
import { Doctor } from "../doctors/Doctor";

const genderOptions = [
  { value: 0, label: "Hombre" },
  { value: 1, label: "Mujer" },
  { value: 2, label: "Otro" },
];
export const User = Object.freeze({
  name: {
    visibleName: "Nombre",
    type: InputTypes.TEXT,
  },
  last_name: {
    visibleName: "Apellido",
    hidden: true,
    type: InputTypes.TEXT,
  },
  /*   email: {
    visibleName: "Email",
    hidden: true,
    type: InputTypes.EMAIL,
  }, */
  age: {
    visibleName: "Edad",
    hidden: true,
    type: InputTypes.NUMBER,
  },
  gender: {
    visibleName: "Género",
    hidden: true,
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: genderOptions,
    },
  },
  height: {
    visibleName: "Altura",
    type: InputTypes.NUMBER,
    units: "cm",
    hidden: true,
  },
  weight: {
    visibleName: "Peso",
    type: InputTypes.NUMBER,
    units: "kg",
    hidden: true,
  },
  password: {
    visibleName: "Contraseña",
    hidden: true,
    pattern: "[0-9]{6}",
    title: "Introduce un número de 6 caracteres",
    placeholder: "Introduce un número de 6 caracteres",
    type: InputTypes.PASSWORD,
  },
  passwordVerification: {
    visibleName: "Repetir contraseña",
    hidden: true,
    type: InputTypes.PASSWORD,
  },
  prefix: {
    visibleName: "Prefijo",
    type: InputTypes.NUMBER,
  },
  telephone_number: {
    visibleName: "Teléfono",
    type: InputTypes.TEXT,
  },
  activity: {
    visibleName: "Nivel de actividad",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  timestamp: {
    visibleName: "Fecha de creación",
    nonEditable: true,
    type: InputTypes.DATE,
  },
  _id: {
    visibleName: "Detalles",
    nonEditable: true,
    type: InputTypes.REDIRECT,
    baseUrl: "/users",
  },
  avoid_diet_cond: {
    visibleName: "Restricciones Alimentarias",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  avoid_diet_pref: {
    visibleName: "Tipo de dieta",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  food_pref_exclusion: {
    visibleName: "Alimentos excluidos",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
      optionsMapping: {
        source: OptionsSources.COLLECTION,
        collection: Aliment,
        property: Aliment._id,
        visibleProperty: Aliment.food_name.composedElements.nameES,
        filter: () => {
          return true;
        },
      },
    },
  },
  cook_time: {
    visibleName: "Tiempo de Preparación",
    type: InputTypes.NUMBER,
    hidden: true,
  },
  difficulty: {
    visibleName: "Dificultad de las recetas",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  midTrainingSuplement: {
    visibleName: "Suplementación Intraentreno",
    type: InputTypes.SELECT,
    hidden: true,
    readOnly: true,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  weight_obj: {
    visibleName: "Peso objetivo",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  weight_obj_macros: {
    visibleName: "Objetivo Macros",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  diet_variety: {
    visibleName: "Variedad de Dietas",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  diet_extended_recipes: {
    visibleName: "Variedad de Recetas",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  bread_types: {
    visibleName: "Tipos de Pan",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Aliment,
      property: Aliment._id,
      visibleProperty: Aliment.food_name.composedElements.nameES,
      filter: () => {
        return true;
      },
    },
  },
  pasta_types: {
    visibleName: "Tipos de Pasta",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Aliment,
      property: Aliment._id,
      visibleProperty: Aliment.food_name.composedElements.nameES,
      filter: () => {
        return true;
      },
    },
  },
  advanced_planning: {
    visibleName: "Plan Avanzado",
    type: InputTypes.TEXT,
    hidden: true,
  },
  advanced_planning: {
    visibleName: "Opciones Avanzadas",
    type: InputTypes.ARRAY,
    hidden: true,
  },
  aliment_exceptions: {
    visibleName: "Alimentos Excluídos",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Aliment,
      property: Aliment._id,
      visibleProperty: Aliment.food_name.composedElements.nameES,
      filter: () => {
        return true;
      },
    },
  },
  active_diet: {
    visibleName: "Dieta Activa",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },
  active_diet_date: {
    visibleName: "Fecha de Inicio de la Dieta",
    type: InputTypes.DATE,
    hidden: true,
    readOnly: true,
  },
  /*   active_diet_date_start_meal: {
    visibleName: "Comida inicial de la dieta activa",
    type: InputTypes.TEXT,
    hidden: true,
    readOnly: true,
  }, */
  diet_complete: {
    visibleName: "Dietas completadas",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
    /*     optionsMapping: {
      source: OptionsSources.BOOLEAN,
    }, */
  },
  diet_complete_global: {
    visibleName: "Dietas completadas globales",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  diet_complete_programs_global: {
    visibleName: "Programas completados globales",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  diet_success: {
    visibleName: "Dieta exitosa",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
    /*     optionsMapping: {
      source: OptionsSources.BOOLEAN,
    }, */
  },
  diet_success_global: {
    visibleName: "Dietas exitosas globales",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  version: {
    visibleName: "Versión de la aplicación",
    type: InputTypes.TEXT,
    hidden: true,
    readOnly: true,
  },
  email: {
    visibleName: "Correo electrónico",
    type: InputTypes.EMAIL,
    hidden: true,
    readOnly: true,
  },
  favorite_doctors: {
    visibleName: "Doctores Favoritos",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Doctor,
      property: Doctor._id,
      visibleProperty: Doctor.name,
      filter: () => {
        return true;
      },
    },
  },
  plan: {
    visibleName: "Plan del Usuario",
    type: InputTypes.TEXT,
    hidden: true,
    readOnly: true,
  },
  plan_validity_start: {
    visibleName: "Fecha de Inicio del Plan",
    type: InputTypes.DATE,
    hidden: true,
    readOnly: true,
  },
  plan_validity_until: {
    visibleName: "Fecha de Vencimiento del Plan",
    type: InputTypes.DATE,
    hidden: true,
    readOnly: true,
  },
  munchy_type: {
    visibleName: "Tipo de Munchy",
    type: InputTypes.NUMBER,
    hidden: true,
    readOnly: true,
  },
  unconfirmedSMS: {
    visibleName: "SMS No Confirmado",
    type: InputTypes.SELECT,
    hidden: true,
    readOnly: true,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  connection_timestamp: {
    visibleName: "Última conexión",
    type: InputTypes.DATE,
    hidden: true,
    readOnly: true,
  },
  favorite_diets: {
    visibleName: "Dietas favoritas",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },

  linked_enabled: {
    visibleName: "Enlace con otros usuarios",
    type: InputTypes.SELECT,
    hidden: true,
    readOnly: true,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },

  //TODO: Crear tipos de objeto para estas variables (excel)

  /*   linked_profile: {
    visibleName: "Perfiles enlazados",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },
  pending_req_rcv: {
    visibleName: "Peticiones de Linkado Recibidas",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },
  pending_req_sent: {
    visibleName: "Peticiones de Linkado Enviadas",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },
  delivery_addresses: {
    visibleName: "Direcciones de Envío",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  },
  invoice_addresses: {
    visibleName: "Direcciones de Facturación",
    type: InputTypes.MULTIPLE_SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: UserDiet,
      property: UserDiet._id,
      visibleProperty: UserDiet.name,
      filter: () => {
        return true;
      },
    },
  }, */
  toString: "User",
});

export const SpecificUserDetails = (userId) => {
  let specificDetails = JSON.parse(JSON.stringify(User));
  specificDetails.active_diet.optionsMapping.collection =
    SpecificUserDiet(userId);
  specificDetails.active_diet.optionsMapping.filter = () => {
    return true;
  };
  return specificDetails;
};
